import React from 'react';
import { t } from '@lingui/core/macro';
import styled from 'styled-components';

import { Paragraph } from '@rover/kibble/core';
import { Alignment } from '@rover/react-lib/src/components/layouts/layout.constants';
import VerticalLayout from '@rover/react-lib/src/components/layouts/VerticalLayout';
import DialogModal from '@rover/react-lib/src/components/modals/DialogModal';

export type Props = {
  message: string;
  onRequestClose: () => void;
};
const StyledModalContent = styled.div`
  padding: ${({ theme }) => theme.space['6x']};
`;

const LocationErrorModal = ({ message, onRequestClose }: Props): JSX.Element => {
  return (
    <DialogModal
      cancelButtonText={null}
      headerText={null}
      isOpen={!!message}
      onClickCancel={null}
      onClickSubmit={onRequestClose}
      onRequestClose={onRequestClose}
      submitButtonText={t`Close`}
    >
      <StyledModalContent>
        <VerticalLayout hAlign={Alignment.CENTER}>
          <Paragraph size="300">{message as string}</Paragraph>
        </VerticalLayout>
      </StyledModalContent>
    </DialogModal>
  );
};

export default LocationErrorModal;
